<div class="floating-window">
  <mat-toolbar class="mat-toolbar-height">
    <div class="nameMarker">
      <mat-icon>place</mat-icon>
      {{"units.coordinates" | translate}}
    </div>

    <lib-button (click)="onClose()" icon="close" color="none" textColor="muted" tooltip="{{'form.close' | translate}}">
    </lib-button>
  </mat-toolbar>

  <div class="coord-input">
    <!-- Groupe Unit/Tracker -->
    <div class="section-title">Informations</div>

    <mat-form-field appearance="outline" class="unitTracker-input" subscriptSizing="dynamic">
      <mat-label>{{"units.unit" | translate}}</mat-label>
      <mat-icon matPrefix>home</mat-icon>
      <input matInput type="string" [(ngModel)]="unitName" id="name" disabled>
    </mat-form-field>

    <mat-form-field appearance="outline" class="unitTracker-input" subscriptSizing="dynamic">
      <mat-label>{{"units.tracker" | translate}}</mat-label>
      <mat-icon matPrefix>location_on</mat-icon>
      <input matInput type="string" [(ngModel)]="trackerName" id="name" disabled>
    </mat-form-field>

    <!-- Groupe Coordinates -->
    <div class="section-title">Coordonnées</div>

    <mat-form-field appearance="outline" class="coord-lat" subscriptSizing="dynamic">
      <mat-label>{{'viewer.lat'|translate}}</mat-label>
      <mat-icon matPrefix>north</mat-icon>
      <input matInput type="number" [(ngModel)]="lat" id="mapLatitude" step="0.00001" [disabled]="!isVirtualMarker()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="coord-lon" subscriptSizing="dynamic">
      <mat-label>{{'viewer.lon'|translate}}</mat-label>
      <mat-icon matPrefix>east</mat-icon>
      <input matInput type="number" [(ngModel)]="lon" id="mapLongitude" step="0.00001" [disabled]="!isVirtualMarker()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="coord-z" subscriptSizing="dynamic">
      <mat-label>{{'viewer.z'|translate}}</mat-label>
      <mat-icon matPrefix>height</mat-icon>
      <input matInput type="number" [(ngModel)]="z" id="mapZ" [disabled]="!isVirtualMarker()">
    </mat-form-field>
  </div>

  <div class="btn-save-div">
    <lib-button *ngIf="clickedMarkerInfo.unit.type == 'virtual' && this.liveState" (click)="save()"
      tooltip="{{'form.save'|translate}}" icon="save"></lib-button>
  </div>
</div>